import React from "react"
import { format, fromUnixTime } from "date-fns"
import { Link } from "gatsby"

function ManualRewnwalNotice({ date, link }) {
  return (
    <div className="bg-red-600 py-6 px-4">
      <div className="container mx-auto px-3 leading-tight">
        <h3 className="text-white font-bold mb-3">Manual Renewal Required</h3>

        <p className="text-white m-0 mb-1">
          Your account will expire on {format(fromUnixTime(date), "dd/MM/yyyy")}
          . If you wish to renew your account and enable automatic renewal,
          please{" "}
          <Link to={link} className="underline font-semibold">
            click here
          </Link>
          .
        </p>
      </div>
    </div>
  )
}

export default ManualRewnwalNotice
